module.exports = __webpack_public_path__ + "img/setup-6.f0bea169.png";